//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {setdevicenotifytype, querymember, delmember, addmember} from '../../api/device'

export default {
  name: 'DeviceMember',
  data () {
    return {
      memberToast: false,
      memberPhone: '',
      memberData: [],
      shareIsg: '请输入手机号',
      isShare: false,
      showAdd: false,
      addText: '',
      addWarn: false,
      warnText: '',
      deviceData: '',
      result: [],
      isNoChange: true
    }
  },
  created () {
    this.golobleObject.getDeviceMember = this.queryMember
    this.deviceData = this.$store.getters.get_child_obj
    this.queryMember()
  },
  mounted () {},
  methods: {
    queryMember () {
      if (this.deviceData.phonedevicerole === 'admin') { // 成员分享
        this.isNoChange = false
      } else {
        this.isNoChange = true
      }
      this.memberData = []
      let item = this.$store.getters.get_child_obj
      let data = {
        did: parseInt(item.id)
      }
      querymember(data).then(res => {
        let arr = res.data
        for (let i = 0; i < arr.length; i++) {
          // "NotifyType": "1110011000"
          // 字符串共十位，按照 0 ～ 9 每位依次是
          // 11100 11 000
          // 微信、短信、电话、备用、备用、6被共享短信、7被共享电话、备用、备用、备用
          // console.log(arr[i].NotifyType)
          arr[i].result = []
          let notifytype = arr[i].NotifyType.split('')
          // console.log(999, arr[i].Phone, notifytype[5], notifytype[6])
          if (notifytype[5] === '1') {
            arr[i].result.push('2')
          }
          if (notifytype[6] === '1') {
            arr[i].result.push('1')
          }
          // arr[i].result = ['1']
          if (arr[i].Role === 'admin') {
            this.memberData.unshift(arr[i])
          } else {
            this.memberData.push(arr[i])
          }
        }
      }).catch(() => {})
    },
    getMemberRole (role) {
      if (role === 'admin') {
        return '管理者'
      } else if (role === 'normal') {
        return '普通用户'
      } else if (role === 'familyshare') {
        return '场所成员'
      } else {
        return role
      }
    },
    addMemberOpen () {
      console.log(111)
      this.memberToast = true
    },
    // 删除成员
    delMember (phone) {
      let item = this.$store.getters.get_child_obj
      let data = {did: item.id, phones: [phone]}
      delmember(data).then(res => {
        this.$toast('删除成功')
        this.queryMember()
      }).catch(() => {})
    },
    isPhone () {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (this.memberPhone === '') {
        this.isShare = true
        this.shareIsg = '请输入手机号'
      } else if (!reg.test(this.memberPhone)) {
        this.isShare = true
        this.shareIsg = '手机号格式错误'
      } else {
        this.isShare = false
      }
    },
    // 添加成员
    sendMember () {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (this.memberPhone === '') {
        this.isShare = true
        this.shareIsg = '请输入手机号'
        return
      } else if (!reg.test(this.memberPhone)) {
        this.isShare = true
        this.shareIsg = '手机号格式错误'
        return
      }
      let item = this.$store.getters.get_child_obj
      let data = {did: item.id, phones: [this.memberPhone]}
      addmember(data).then(res => {
        this.$toast('添加成功')
        this.memberToast = false
        this.memberPhone = ''
        this.queryMember()
      }).catch(() => {})
    },
    changeType (item) {
      // 2 短信6 1 语音7
      console.log(item, this.memberData)
      let notifytype = item.NotifyType
      notifytype = notifytype.slice(0, 5) + '00' + notifytype.slice(7)
      let result = item.result
      for (let i = 0; i < result.length; i++) {
        if (result[i] === '2') {
          notifytype = notifytype.slice(0, 5) + '1' + notifytype.slice(6)
        } else if (result[i] === '1') {
          notifytype = notifytype.slice(0, 6) + '1' + notifytype.slice(7)
        }
      }
      let data = {
        phone: item.Phone,
        did: item.Did,
        notifytype
      }
      setdevicenotifytype(data).then(res => {
        if (res.code === 200) {
          this.showAdd = true
          this.addText = '成功'
        } else {
          this.addWarn = true
          this.warnText = '失败'
          this.queryMember()
        }
      }).catch(() => {
        this.addWarn = true
        this.warnText = '失败'
        this.queryMember()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/device/DeviceMember.vue